export const PRO_SUBSCRIPTION_PRICE_LABEL = '$49/mo';
export const PRO_SUBSCRIPTION_SHORT_COPY = `Subscribe to unlock all - ${PRO_SUBSCRIPTION_PRICE_LABEL}`;

export const formatSharedBundleAccessLabel = (lockedCount: number) => {
	return `Access ${lockedCount} shared Property Bundle${lockedCount !== 1 ? 's' : ''}`;
};
